import { Observable } from "rxjs";
import { EndpointsName, put, get, deleteMethod } from "../../Auth";
import { AWRCParsedStreamData, IBlendHistorianParam } from "../../types";
import { getGraphQLAWRCDataObservable } from "./AWRCGraphQLService";
import { getAWRCDataObservable } from "./AWRCModel";

export const getAWRCSolutionData = (): Observable<
  Partial<AWRCParsedStreamData>
> => getAWRCDataObservable();
export const getAWRCLastBatchButton = () =>
  put(EndpointsName.BBF, `/AWRC/lastBatchButton`, null);
export const getBlendHistorianParams = (blendName: string) =>
  get<IBlendHistorianParam[]>(EndpointsName.HISTORICAL, `/${blendName}`);
export const resetBlendHistorianParams = (blendName: string) =>
  deleteMethod(EndpointsName.HISTORICAL, `/${blendName}`);
export const postBlendHistorianParams = (
  blendName: string,
  updatedHistoricalData: IBlendHistorianParam[]
) =>
  put(
    EndpointsName.HISTORICAL,
    `/${blendName}`,
    updatedHistoricalData
  );

export const getGraphQLAWRCSolutionData = (): Observable<
  Partial<AWRCParsedStreamData>
> => getGraphQLAWRCDataObservable();
